// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"chevron-down-double-s"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M8.46484 7.50177L12.0004 11.0373L15.5359 7.50177M8.46484 12.9627L12.0004 16.4982L15.5359 12.9627","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const ChevronDownDoubleSIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'chevron-down-double-s',
    ref,
    icon: element,
  },
));

ChevronDownDoubleSIcon.displayName = 'ChevronDownDoubleSIcon';

export default ChevronDownDoubleSIcon;
